import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';

// Status polling for the adjustment applied asynchronously by payout_order_processor (~30s max)
const STATUS_POLL_INTERVAL_MS = 2000;
const STATUS_POLL_ATTEMPTS = 15;

@Component({
  selector: 'app-adjust-gateway-wallet',
  templateUrl: './adjust-gateway-wallet.component.html',
  styleUrls: ['./adjust-gateway-wallet.component.css'],
})
export class AdjustGatewayWalletDialog {
  wallet: any = {};
  myForm: any;
  isSubmitting: boolean = false;
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<AdjustGatewayWalletDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    public userService: UserService
  ) {
    this.wallet = data.wallet || {};
    this.myForm = this.fb.group({
      TxnType: ['CREDIT', [Validators.required]],
      Amount: ['', [Validators.required, Validators.min(0.01)]],
      Note: ['', [Validators.required, Validators.maxLength(200)]],
    });
  }

  get currentBalance(): number {
    return Number(this.wallet.Balance) || 0;
  }

  get newBalance(): number {
    const amount = Number(this.myForm.get('Amount').value) || 0;
    return this.myForm.get('TxnType').value === 'DEBIT' ? this.currentBalance - amount : this.currentBalance + amount;
  }

  onSubmit() {
    if (this.myForm.invalid || this.isSubmitting) {
      return;
    }
    if (this.newBalance < 0) {
      this.errorMessage = 'Debit cannot be more than the current balance';
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    this.userService.createGatewayWalletAdjustment({
      _csrf: this.data._csrf,
      GatewayCode: this.wallet.GatewayCode,
      MId: this.wallet.MId,
      TxnType: this.myForm.get('TxnType').value,
      Amount: Number(this.myForm.get('Amount').value),
      Note: this.myForm.get('Note').value,
    }).subscribe(
      (response: any) => this.pollStatus(response.RefId, STATUS_POLL_ATTEMPTS),
      (error) => {
        this.isSubmitting = false;
        this.errorMessage = (error && error.error && error.error.message) || 'Failed to submit adjustment';
      }
    );
  }

  private pollStatus(refId: string, attemptsLeft: number) {
    setTimeout(() => {
      this.userService.getGatewayWalletAdjustmentStatus({ _csrf: this.data._csrf, RefId: refId }).subscribe(
        (status: any) => {
          if (status && status.Status === 'SUCCESS') {
            this.dialogRef.close({ success: true, message: 'Adjustment applied' });
          } else if (status && status.Status === 'FAILED') {
            this.dialogRef.close({ success: false, failed: true, message: `Adjustment not applied: ${status.Message || 'unknown error'}` });
          } else if (attemptsLeft > 1) {
            this.pollStatus(refId, attemptsLeft - 1);
          } else {
            // Still queued: it will be applied once the processor picks it up, check the ledger
            this.dialogRef.close({ success: true, pending: true, message: `Adjustment ${refId} submitted, still processing. Check the ledger shortly.` });
          }
        },
        () => {
          if (attemptsLeft > 1) {
            this.pollStatus(refId, attemptsLeft - 1);
          } else {
            this.dialogRef.close({ success: true, pending: true, message: `Adjustment ${refId} submitted, status unknown. Check the ledger.` });
          }
        }
      );
    }, STATUS_POLL_INTERVAL_MS);
  }

  onCancel() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/gateway-wallet/adjust-gateway-wallet/adjust-gateway-wallet.component.ts